import DIContainer from 'services/DIContainer';
import { DocumentTemplateResponseDTO } from '../../typings/dto/documentTemplate';
import Mapper from './Mapper';

export default class DocumentTemplateMapper extends Mapper<DocumentTemplate, DocumentTemplateResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers) {
    super({
      name: 'name',
      tenantId: 'tenantId',
      fileId: 'file',
    });
  }

  public responseDTOToModel = (dto: DocumentTemplateResponseDTO): DocumentTemplate => {
    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      file: dto.fileId ? this.subEntitiesMappers.file.responseDTOToModel(dto.fileId) : null,
    };
  };
}
